import { render } from "./logistics-list.vue?vue&type=template&id=3ccb3ece&scoped=true&ts=true"
import script from "./logistics-list.vue?vue&type=script&lang=ts"
export * from "./logistics-list.vue?vue&type=script&lang=ts"

import "./logistics-list.vue?vue&type=style&index=0&id=3ccb3ece&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccb3ece"]])

export default __exports__